import React from "react";
import { useParams } from "react-router-dom";
import { useCampaign } from "src/queries/hooks/campaignManager";
import HyroBreadcrumbs from "@hyro-components/hyro-breadcrumbs/HyroBreadcrumbs";
import { capitalize } from "@utils";

const CampaignManagerBreadcrumbs = () => {
  const { campaignId, accountId } = useParams();
  const baseUrl = `/${accountId}/`;
  const { data: campaign } = useCampaign({ campaignId, accountId });

  const breadcrumbs = [
    capitalize(accountId).replace(/[_-]/, " "),
    "Campaign Manager",
    ...(campaign?.campaignName ? [campaign?.campaignName] : [])
  ];

  return <HyroBreadcrumbs
    breadcrumbs={breadcrumbs}
    baseUrl={baseUrl}
  />;
};

export default CampaignManagerBreadcrumbs;
